export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 4_10.d8fadc5b.jpg";